import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import MsalLogin from './authentication/MsalLogin';
import { LayoutContextProvider } from './context/LayoutContext';
import { StoreProvider } from './context/Provider';
import { MainLayout } from './layout/MainLayout';
import RouterConfig from './routes/RouterBrowser';
import { HeaderProvider } from './serviceContextManager/layout/HeaderServiceManager';
import { LocationProvider } from './context/LocationProvider';

const App = () => {
  return (
    <>
      {/*  <PrimeReactProvider> */}
      <MsalLogin>
        <LocationProvider>
          <StoreProvider>
            <BrowserRouter>
              <HeaderProvider>
                <LayoutContextProvider>
                  <Routes>
                    <Route path="/" element={<MainLayout />}>
                      {RouterConfig()}
                    </Route>
                  </Routes>
                </LayoutContextProvider>
              </HeaderProvider>
            </BrowserRouter>
          </StoreProvider>
        </LocationProvider>
      </MsalLogin>
      {/* </PrimeReactProvider> */}
    </>
  );
};

export default App;
